import React from 'react';
import IconTick from 'oldAssets/images/icons/tick-turquoise.svg';
import Button from 'commonComponents/Button/Button';
import styles from './Locations.module.scss';

const Locations = ({ locations, moreLocations, learnMore }) => {
  return ( 
    <section className={ styles.Locations }>
      { locations.map(( data ) => 
        <Location { ...data } key={ data.city }
          more={ learnMore }
        />) 
      }
      <div className={ styles.moreLocations }>{ moreLocations }</div>
    </section>
  );
};

const Location = ({ city, photo, description, text, features, link, more }) => (
  <div className={ styles.Location }>
    <figure>
      <img src={ photo } alt={ city }
        width="390" height="500"
      />
    </figure>
    <article>
      <h3>
        { city } - { description }
      </h3>
      <p>{ text }</p>
      <ul>
        { features.map(item => (
          <li key={ item }>
            <img src={ IconTick } width="18"
              height="18"
            />{ item }
          </li>
        )) }
      </ul>
      <Button label={ more } link={ link }
        type="middle"
      />
    </article>
  </div>
);
 
export default Locations;